import { BaseApiService } from "../base/base-api.service";
import { LegalEntityCashStatementDTO } from "../../models/legal-entity-cash-statement/legal-entity-cash-statement-dto";
import { LegalEntityCashStatementSTO } from "../../models/legal-entity-cash-statement/legal-entity-cash-statement-sto";
import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { LegalEntityCashStatementFilter } from "../../models/legal-entity-cash-statement/legal-entity-cash-statement-filter";

export class LegalEntityCashStatementApiService extends BaseApiService<
  LegalEntityCashStatementDTO,
  LegalEntityCashStatementSTO
> {
  constructor() {
    super({
      servicePath: "/LegalEntityCashStatements",
      loadItemsPath: "/GetLegalEntityCashStatements",
      saveItemsPath: "/SaveLegalEntityCashStatements",
    });
  }
}

export const loadLegalEntityCashStatements = async (id?: string) => {
  const response = await new LegalEntityCashStatementApiService().loadItems({
    legalEntityIds: [id as string],
  } as LegalEntityCashStatementFilter);

  toastifyResponse(response, "failed");

  return response;
};

export const saveLegalEntityCashStatements = async (cashStatements: LegalEntityCashStatementSTO) => {
  const response = await new LegalEntityCashStatementApiService().saveItems([cashStatements]);

  toastifyResponse(response, "all", "default_success_message", "failure_saving_data", "error_saving_data");

  return response;
};
